var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergiBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "energi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.9 162.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "f1417617-549d-40d0-83e5-86ad6f15869d",
    "data-name": "border",
    d: "M44.05,33S50.91,10.87,73.51,3.21c27.77-9.4,60.28,8.34,64.85,12.37s1.26,29.72-8.06,54.28c-8.87,23.38-34.48,23.92-34.48,23.92l4.87,43,21.82,1.88s-1.35,5.37-1.35,5.66,10,4.82,10.21,5.89-17.14,11.29-18.27,12.1-50.16-2.13-50.16-2.13l-4.78-10.46-34-4.6,21.38-7.45s8.3-6.84-19.73-25.62c-15.65-10.48-7.56-52.86-7.56-52.86H.5V33.31Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiBorder);
export default __webpack_public_path__ + "static/media/energi-border.0740e685.svg";
export { ForwardRef as ReactComponent };